<fin-corporate-widget [imageFromFragment]="'CORPORATE.fragments.benefitWidgetImage'">
  <h4 class="font-heading-4 ms-large-b">{{ 'CORPORATE.corporatePortal.widgets.benefits.title' | finLocalization }}</h4>
  <div class="flex font-body-1 benefit-container">
    <div class="flex-1 column fill--50 medium-type ps-medium-r">
      <div class="flex ms-medium-b">
        <fcom-icon
          [name]="SvgLibraryIcon.SEAT_OR_ECONOMY_BLOCK"
          class="ms-small-r ms-xxsmall-t icon-large flex--nogrow"
        ></fcom-icon>
        <span>{{ 'CORPORATE.corporatePortal.widgets.benefits.benefit1' | finLocalization }}</span>
      </div>
      <div class="flex ms-medium-b">
        <fcom-icon
          [name]="SvgLibraryIcon.DISCOUNTED_PRICE_BLOCK"
          class="ms-small-r ms-xxsmall-t icon-large flex--nogrow"
        ></fcom-icon>
        <span>{{ 'CORPORATE.corporatePortal.widgets.benefits.benefit2' | finLocalization }}</span>
      </div>
      <div class="flex">
        <fcom-icon
          [name]="SvgLibraryIcon.PRIORITY_SECURITY_BLOCK"
          class="ms-small-r ms-xxsmall-t icon-large flex--nogrow"
        ></fcom-icon>
        <span>{{ 'CORPORATE.corporatePortal.widgets.benefits.benefit3' | finLocalization }}</span>
      </div>
    </div>
    <div class="flex-1 column fill--50 regular-type">
      <span>{{ 'CORPORATE.corporatePortal.widgets.benefits.description' | finLocalization }}</span>
    </div>
  </div>
</fin-corporate-widget>
